"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _colors = require("HubStyleTokens/colors");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _Breakpoints = require("pricing-pages-unified-ui/constants/Breakpoints");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UITile = _interopRequireDefault(require("UIComponents/tile/UITile"));

var _FeaturesModal = _interopRequireDefault(require("./FeaturesModal"));

var _getFeatureDescriptionKey = _interopRequireDefault(require("self-service-api/core/utilities/getFeatureDescriptionKey"));

var _ChecklistItem = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/ChecklistItem"));

var TileFeatureListContainer = _styledComponents.default.div.withConfig({
  displayName: "FeatureTile__TileFeatureListContainer",
  componentId: "igrbmj-0"
})(["padding:45px 25px 15px;"]);

var TileHeader = _styledComponents.default.div.withConfig({
  displayName: "FeatureTile__TileHeader",
  componentId: "igrbmj-1"
})(["font-size:15px;font-weight:700;text-transform:uppercase;margin-bottom:27px;"]);

var TileViewMoreContainer = _styledComponents.default.div.withConfig({
  displayName: "FeatureTile__TileViewMoreContainer",
  componentId: "igrbmj-2"
})(["width:100%;padding:10px 25px;border-top:1px solid ", ";font-size:14px;text-align:center;"], _colors.KOALA);

var FeatureTileContainer = (0, _styledComponents.default)(_UITile.default).withConfig({
  displayName: "FeatureTile__FeatureTileContainer",
  componentId: "igrbmj-3"
})(["display:flex;flex-direction:column;margin-top:0 !important;flex:1;@media (min-width:", "px){&:first-child{margin-right:10px;}&:last-child{margin-left:10px;}}@media (max-width:", "px){&:first-child{margin-bottom:10px;}&:last-child{margin-top:10px;}}"], _Breakpoints.FEATURES_SECTION, _Breakpoints.FEATURES_SECTION - 1);

function FeatureTile(_ref) {
  var modalViewClassName = _ref.modalViewClassName,
      header = _ref.header,
      features = _ref.features,
      hubType = _ref.hubType,
      merchandiseId = _ref.merchandiseId;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      featuresModalVisible = _useState2[0],
      setFeaturesModalVisible = _useState2[1];

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(FeatureTileContainer, null, _react.default.createElement(TileFeatureListContainer, null, _react.default.createElement(TileHeader, null, header), Object.keys(features).slice(0, 5).map(function (feature) {
    return _react.default.createElement(_ChecklistItem.default, {
      key: feature,
      tooltipMessage: (0, _getFeatureDescriptionKey.default)(feature, hubType),
      message: "pricing-pages.features." + feature + ".name",
      className: "m-bottom-4"
    });
  })), _react.default.createElement("div", {
    className: "flex flex-grow-1 align-end"
  }, _react.default.createElement(TileViewMoreContainer, null, _react.default.createElement(_UIButton.default, {
    className: modalViewClassName,
    use: "link",
    onClick: function onClick() {
      setFeaturesModalVisible(true);
    }
  }, _react.default.createElement(_FormattedMessage.default, {
    className: modalViewClassName,
    message: "pricingPage.pages.crm.viewMore"
  }))))), featuresModalVisible && _react.default.createElement(_FeaturesModal.default, {
    merchandiseId: merchandiseId,
    header: header,
    features: features,
    hubType: hubType,
    onModalClose: function onModalClose() {
      setFeaturesModalVisible(false);
    }
  }));
}

var _default = FeatureTile;
exports.default = _default;
module.exports = exports.default;